'use strict';
var carswip = carswip || {};
const siteHeader = document.getElementById('js-site-header');

carswip.siteHeader = carswip.siteHeader || function () {
	function init() {
		let lastScrollTop = 0;
        if(window.scrollY > 0) {
			siteHeader.classList.add('site-header--dark');
		}
		document.addEventListener("scroll", function() {
            var st = window.pageYOffset || document.documentElement.scrollTop;

            if(lastScrollTop > 70) {
                siteHeader.classList.add('site-header--dark');
            } else {
                siteHeader.classList.remove('site-header--dark');
            }
			lastScrollTop = st <= 0 ? 0 : st;
        }, false);
	}
	return {
		init : init
	};
}();